import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, Download, FileText, AlertTriangle, ArrowLeft } from "lucide-react";
import { API } from "../lib/api";

export default function DownloadPage() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");

  const load = () => {
    fetch(`${API}/download/${token}`)
      .then(async (r) => {
        if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.detail || "Link non valido."); }
        return r.json();
      })
      .then((d) => { setInfo(d); setState("ready"); })
      .catch((e) => { setError(e.message); setState("error"); });
  };

  useEffect(load, [token]);

  const fmtDate = (s) => { try { return new Date(s).toLocaleString("it-IT", { dateStyle: "medium", timeStyle: "short" }); } catch { return s; } };

  return (
    <div className="min-h-screen bg-[var(--paper-2)] flex items-center justify-center px-6 py-16" data-testid="download-page">
      <div className="w-full max-w-lg bg-white border border-[var(--line)] p-8 sm:p-12">
        <div className="flex items-center gap-3 mb-8">
          <span className="font-serif text-base w-10 h-10 flex items-center justify-center border border-[var(--gold)] text-[var(--gold)]">GR</span>
          <span className="font-serif text-lg text-[var(--petrol)]">Gabriella Ritondo</span>
        </div>

        {state === "loading" && <div className="py-10 flex justify-center"><Loader2 className="animate-spin text-[var(--petrol)]" size={36} /></div>}

        {state === "error" && (
          <div className="text-center py-6" data-testid="download-error">
            <AlertTriangle className="mx-auto text-[var(--gold)] mb-4" size={40} strokeWidth={1.25} />
            <h1 className="font-serif text-2xl text-[var(--ink)] mb-2">Link non disponibile</h1>
            <p className="text-[var(--ink-soft)]">{error}</p>
            <p className="text-sm text-[var(--ink-soft)] mt-4">Per un nuovo link, contatta <a className="text-[var(--accent)] link-underline" href="mailto:gabriellaritondo@gmail.com">gabriellaritondo@gmail.com</a>.</p>
          </div>
        )}

        {state === "ready" && info && (
          <div data-testid="download-ready">
            <div className="overline mb-3">Il tuo download</div>
            <h1 className="font-serif text-3xl text-[var(--ink)] mb-6">{info.product_name}</h1>
            <div className="space-y-3">
              {info.files.map((f) => (
                <a key={f.file_id} href={`${API}/download/${token}/${f.file_id}`} data-testid={`dl-${f.file_id}`}
                  className="btn-fill flex items-center justify-between gap-3 border border-[var(--petrol)] text-[var(--petrol)] hover:text-white px-5 py-4"
                  onClick={() => setTimeout(load, 1500)}>
                  <span className="flex items-center gap-3 text-sm font-medium"><FileText size={18} strokeWidth={1.5} /> {f.filename}</span>
                  <Download size={18} strokeWidth={1.75} />
                </a>
              ))}
            </div>
            <div className="mt-6 text-xs text-[var(--ink-soft)] border-t border-[var(--line)] pt-4 space-y-1">
              <div>Download rimanenti: <strong>{info.downloads_left}</strong></div>
              <div>Link valido fino al: <strong>{fmtDate(info.expires_at)}</strong></div>
            </div>
          </div>
        )}

        <Link to="/" className="mt-8 inline-flex items-center gap-2 text-sm text-[var(--ink-soft)] hover:text-[var(--petrol)] link-underline">
          <ArrowLeft size={15} strokeWidth={1.5} /> Torna al sito
        </Link>
      </div>
    </div>
  );
}
